import { render, staticRenderFns } from "./dataCenter.vue?vue&type=template&id=5101eea1&"
import script from "./dataCenter.vue?vue&type=script&lang=js&"
export * from "./dataCenter.vue?vue&type=script&lang=js&"
import style0 from "./dataCenter.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports